import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  defaultCalendarStrings,
  ComboBox,
  TooltipHost,
  DatePicker,
  defaultDatePickerStrings,
} from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ChoiceGroup } from "@fluentui/react";

import "./Analytics.css";
import { t } from "i18next";
import { MODEL_OPTIONS, USERTYPES } from "../../constants/Constants";
import ClearIcon from "../../components/SVGComponents/ClearIcon";
import Moment from "moment";
import { filter } from "underscore";
import ProductivityGainFilters from "./ProductivityGainFilters";


const primaryButtonHoverStyles = {
  rootHovered: {
    color: "white",
  },
};

const AnalyticsFilter = (props) => {
  const ref = useRef(null);
  const { onClickOutside } = props;
  const [selectedUserIds, setSelectedUserIds] = useState(props.userIds);
  const [showFilters, setShowFilters] = useState(false);

  const [showFilterButton, setShowFilterButton] = useState(
    props.chartType === "ai_tat_analysis" || props.chartType === "study_throughput" || props.chartType === "tat_analysis" || props.chartType === "radiologist_tat_trend" || props.chartType === "ai_result"
  );

  useEffect(() => {
    if (props.chartType === "ai_tat_analysis" || props.chartType === "study_throughput" || props.chartType === "tat_analysis" || props.chartType === "radiologist_tat_trend" || props.chartType === "ai_result") {
      setShowFilterButton(true);
    } else {
      setShowFilterButton(false);
    }
  }, [props.chartType]);

  

  const getConsistentDateFormat = (date) => {
    if (Moment(date).isValid()) {
      return Moment(date).format("DD-MMM-YY");
    } else {
      return "No Date";
    }
  };

  // const oneHourIntervalTimes = Array.from({ length: 24 }, (_, i) => {
  //   const hour = i.toString().padStart(2, "0");
  //   return `${hour}:00`;
  // });

  const oneHourIntervalTimes = Array.from({ length: 24 }, (_, i) => {
    const hour = i % 12 === 0 ? 12 : i % 12;
    const period = i < 12 ? "AM" : "PM";
    const display = `${hour} ${period}`;
    return { key: `${i.toString().padStart(2, "0")}:00`, text: display };
  });


  const today = new Date();
  let toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const selectDateFrom = (date) => {
    // var formattedDate = formatDate(date);
    props.setFilterObjInChartComponent({ ...props.filterObjInChartComponent, dateFrom: date });
  };

  const selectDateTo = (date) => {
    // var formattedDate = formatDate(date);
    props.setFilterObjInChartComponent({ ...props.filterObjInChartComponent, dateTo: date });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  if (!props.show) return null;

  const handleClearButtonForModality = () => {
    props.setModalityIds([]);
  };

  const handleClearButtonForUser = () =>{
      // setSelectedUserIds([]);
      props.setUserIds([]);
  }

  const handleClearButtonForReturnedReasons = () =>{
    props.setReturnedReasonIds([]);
  }

  const handleClearButtonForRaiseAlertReasons = () => {
    props.setRaiseAlertReasonIds([]);
  }

  const customStyles = {
    // Note that this is actually the wrapper of the input and caret (doesn't include the label)
    optionText:{   
        textWrap: "wrap",
    },
    label:{
        alignItems:"flex-start"
    },
  };

  const getSelectedNames = (selectedKeys, options) => {
    if (!selectedKeys || !options) return [];
    return options
      .filter(opt => opt && selectedKeys.includes(opt.key))
      .map(opt => opt.text || opt.label || opt.name);
  };

const selectedFilters = [];
// if (props.filterObjInChartComponent && props.filterObjInChartComponent.fullDay) {
//   selectedFilters.push("Full Day: Selected");
// }
if (props.modalityIds && props.modalityIds.length > 0 && props.modalityList)
  selectedFilters.push(
    `Modality: ${getSelectedNames(props.modalityIds, props.modalityList).join(', ')}`
  );
if (props.clientIds && props.clientIds.length > 0 && props.clientList)
  selectedFilters.push(
    `Client: ${getSelectedNames(props.clientIds, props.clientList).join(', ')}`
  );
if (props.bodyParts && props.bodyParts.length > 0 && props.xrayBodyParts)
  selectedFilters.push(
    `Body Parts: ${getSelectedNames(props.bodyParts, props.xrayBodyParts).join(', ')}`
  );
if (props.pathologyIds && props.pathologyIds.length > 0 && props.annotationList)
  selectedFilters.push(
    `Findings: ${getSelectedNames(props.pathologyIds, props.annotationList).join(', ')}`
  );
if (props.providerIds && props.providerIds.length > 0 && props.providerList)
  selectedFilters.push(
    `Provider: ${getSelectedNames(props.providerIds, props.providerList).join(', ')}`
  );
if (props.userIds && props.userIds.length > 0 && props.userList)
  selectedFilters.push(
    `Radiologist: ${getSelectedNames(props.userIds, props.userList).join(', ')}`
  );

if (props.aiModel && props.aiModel.length > 0)
  selectedFilters.push(
    `AI Model: ${getSelectedNames(props.aiModel, MODEL_OPTIONS).join(', ')}`
  );

if (props.normality && props.normality !== "total") {
  const displayText = props.normality.toLowerCase() === "normal"
    ? "Normal"
    : props.normality.toLowerCase() === "abnormal"
    ? "Abnormal"
    : "Average";

  //selectedFilters.push(`AI Result: ${displayText}`);
}

const selectedCount = selectedFilters.length;
const NORMALITY_OPTIONS = [
    { key: "total", text: "All" },
    { key: "normal", text: "Normal" },
    { key: "abnormal", text: "Abnormal" },
  ];
  return (
    <>
    {/* 3 */}
      <div className="filter-popup-analytics" ref={ref} style={{
            // width: "40%",
            display: "flex",
            flexDirection: "column",
            borderRight: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "1px solid rgb(88, 88, 88)" : "",
            paddingRight: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "10px" : ""
            }}
      >
      {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") && 
      <div
          style={{
            // width: "40%",
            display: "flex",
            // marginLeft: "20px",
            alignItems:"center",
            paddingTop:"10px"
          }}
        >
          <div style={{ display: "flex"}}>
            <PrimaryButton
              onClick={() => {
                props.setDateByInComponent(1);
              }}
              text={t("analytics.assignment-date")}
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                borderTopLeftRadius: "30px",
                borderBottomLeftRadius: "30px",
                zIndex: props.dateByInComponent !== 1 ? "" : "100",
                background: props.dateByInComponent !== 1 ? "black" : "",
                outline: "white",
                borderTopRightRadius: props.dateByInComponent == 1 ? "30px" : "",
                borderBottomRightRadius: props.dateByInComponent == 1 ? "30px" : "",
                paddingRight: props.dateByInComponent !== 1 ? "10px" : "",
              }}
              styles={primaryButtonHoverStyles}
            />
            <PrimaryButton
              onClick={() => {
                props.setDateByInComponent(2);
              }}
              text={t("analytics.study-date")}
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                marginLeft: "-12px",
                borderTopRightRadius: "30px",
                borderBottomRightRadius: "30px",
                paddingLeft: props.dateByInComponent !== 2 ? "10px" : "",
                background: props.dateByInComponent !== 2 ? "black" : "",
                zIndex: props.dateByInComponent !== 2 ? "" : "100",
                borderTopLeftRadius: props.dateByInComponent == 2 ? "30px" : "",
                borderBottomLeftRadius: props.dateByInComponent == 2 ? "30px" : "",
              }}
              styles={primaryButtonHoverStyles}
            />
          </div>
          {props.dateList != undefined && (
          <>
            <div className="client-filter-section-analytics align-filter-section" style={{width:"120px"}}>
              <ComboBox
                selectedKey={props.selectedDate}
                // selectedKey={selectedUserIds}
                placeholder="Select Date"
                options={[...props.dateList]}
                calloutProps={{ doNotLayer: true }}
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    props.setSelectedDate(() =>option.key);
                  }
                }}
              />
            </div>
          </>
          )}
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            style={{ width: "180px", margin:"5px",marginBottom:"0px",padding:"0px" }}
            name="dob"
            value={props.filterObjInChartComponent.dateFrom}
            onSelectDate={selectDateFrom}
            strings={defaultDatePickerStrings}
            placeholder={t("analytics.from")}
            maxDate={today}
            formatDate={getConsistentDateFormat}
            disabled={props.selectedDate == 6 ? false : true}
          />
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            style={{ width: "180px", margin:"5px",marginBottom:"0px",padding:"0px" }}
            name="dob"
            value={props.filterObjInChartComponent.dateTo}
            onSelectDate={selectDateTo}
            strings={defaultDatePickerStrings}
            placeholder={t("analytics.to")}
            maxDate={toDate}
            formatDate={getConsistentDateFormat}
            disabled={props.selectedDate == 6 ? false : true}
          />
        </div>
        }
        {(props.chartType === "ai_tat_analysis" || props.chartType === "study_throughput" || props.chartType === "tat_analysis" ) &&
          <div style={{
              display: "flex",
              flexDirection:"row-reverse",
              justifyContent: "left",
              paddingBottom: "5px",
            }}>

              {!props.isPortraitMode && (
              <TooltipHost
                content={selectedCount > 0 ? selectedFilters.join(' | ') : t('No filters selected')}
                calloutProps={{ gapSpace: 0 }}
                styles={{ root: { marginLeft: 0, cursor: 'pointer', display: 'inline-block' } }}
              >
                <PrimaryButton
                  className="filter-button-section-analytics"
                  iconProps={{
                    iconName: 'AddTo',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setShowFilters((prev) => !prev);
                  }}
                  text={
                    selectedCount > 0
                      ? `${t('productivity-gain.more-filters')} (${selectedCount})`
                      : t('productivity-gain.more-filters')
                  }
                  styles={{
                    root: selectedCount > 0
                      ? { borderColor: "#0078d4", fontWeight: 600 }
                      : {}
                  }}
                />
              </TooltipHost>
              )}
              {/* Show filter summary icon if any filter is selected */}

              {(showFilters || props.showMoreFilters) && (
                <ProductivityGainFilters
                  role={props.role}
                  modalityList={props.modalityList}
                  modalityIds={props.modalityIds}
                  chartType={props.chartType}
                  setModalityIds={props.setModalityIds}
                  bodyParts={props.bodyParts}
                  setClientIds={props.setClientIds}
                  clientIds={props.clientIds}
                  setPathologyIds={props.setPathologyIds}
                  pathologyIds={props.pathologyIds}
                  setUserIds={props.setUserIds}
                  userIds={props.userIds}
                  setProviderIds={props.setProviderIds}
                  providerIds={props.providerIds}
                  setBodyParts={props.setBodyParts}
                  aiModel={props.aiModel}
                  setAiModel={props.setAiModel}
                  setAlertSuccessModal={props.setAlertSuccessModal}
                  alertSuccessModal={props.alertSuccessModal}
                  handleClearButtonForModality={handleClearButtonForModality}
                  onClickOutside={() => {
                    setShowFilters(false);
                    if (props.setShowMoreFilters) props.setShowMoreFilters(false);
                  }}
                  clientList={props.clientList}
                  xrayBodyParts={props.xrayBodyParts}
                  filterObjInChartComponent={props.filterObjInChartComponent}
                  setFilterObjInChartComponent={props.setFilterObjInChartComponent}
                  normality={props.normality}
                  setNormality={props.setNormality}
                />
              )}
              {/* {props.chartType === "ai_tat_analysis"  && (
                        <>
                          <div style={{ flexDirection: "row" ,marginTop: "23px",width:"103px"}}
                          >
                            <ComboBox
                              selectedKey={props.normality}
                              placeholder="Select Normality"
                              options={NORMALITY_OPTIONS}
                              calloutProps={{ doNotLayer: true }}
                              allowFreeInput
                              autoComplete="on"
                              onChange={(e, option) => {
                                if (option) {
                                  props.setNormality(option.key);
                                }
                              }}
                            />
                          </div>
                        </>
                      )} */}
                 {!props.filterObjInChartComponent.fullDay && (     
                <div style={{ display: "flex", flexDirection: "column", marginTop: "0px" }}>
                <label style={{ fontSize: "12px", fontWeight: 500, marginBottom: "-5px", marginLeft: "5px",fontFamily:"sans-serif" }}>
                  Time Range 
                </label>
                <div style={{ display: "flex", gap: "1px" }}>
                  <div className="timepicker-filter-section-analytics align-filter-section" style={{flexDirection:"row", marginTop: "5px",width: "80px"}}>
                <ComboBox
                  placeholder="-- : --"
                  selectedKey={props.filterObjInChartComponent.timeFrom}
                  options={oneHourIntervalTimes}
                  onChange={(e, option) => {
                    if (option) {
                      props.setFilterObjInChartComponent((prev) => ({
                        ...prev,
                        timeFrom: option.key
                      }));
                    }
                  }}
                  allowFreeInput={false}
                  // multiSelect
                  calloutProps={{ doNotLayer: true }}
                  disabled={props.filterObjInChartComponent.fullDay}
                />
              </div>
                <div className="timepicker-filter-section-analytics align-filter-section" style={{flexDirection:"row", marginTop: "5px",width: "80px"}}>
                <ComboBox
                  placeholder="-- : --"
                  selectedKey={props.filterObjInChartComponent.timeTo}
                  options={oneHourIntervalTimes}
                  onChange={(e, option) => {
                    if (option) {
                      props.setFilterObjInChartComponent((prev) => ({
                        ...prev,
                        timeTo: option.key
                      }));
                    }
                  }}
                  allowFreeInput={false}
                  calloutProps={{ doNotLayer: true }}
                  disabled={props.filterObjInChartComponent.fullDay}
                />
              </div>             
              </div>
              </div>
                 )}
               <div style={{ display: "flex", flexDirection: "column"}}>
              <label style={{ marginBottom: "-5px", fontSize: "12px", fontWeight: 500 ,marginLeft: "5px", fontFamily: "sans-serif" }}>
                {/* Reported Date Range */}
                    {props.filterObjInChartComponent.fullDay ? "Reported Date" : "Reported Date Range"}
                </label>
              <div style={{ display: "flex", gap: "1px" }}>               
              <DatePicker
                className="dform-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                name="dob"
                style={{ width: "120px", marginTop: "5px", marginBottom: "5px", padding:"0px 4px" }}
                value={props.filterObjInChartComponent.dateFrom}
                onSelectDate={selectDateFrom}
                strings={defaultDatePickerStrings}
                placeholder={t("analytics.from")}
                maxDate={today}
                formatDate={getConsistentDateFormat}
              />
                {!props.filterObjInChartComponent.fullDay && (
              <DatePicker
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                // style={{ width: "180px", margin:"5px",marginBottom:"0px",padding:"0px" }}
                name="dob"
                style={{ width: "115px",  marginTop: "5px", marginBottom: "5px", padding:"0px 4px" }}
                value={props.filterObjInChartComponent.dateTo}
                onSelectDate={selectDateTo}
                strings={defaultDatePickerStrings}
                placeholder={t("analytics.to")}
                maxDate={today}
                formatDate={getConsistentDateFormat}
                // disabled={props.selectedDate == 6 ? false : true}
                disabled={props.filterObjInChartComponent.fullDay}
              />
                )}
          </div>
          </div>
          </div>
        }
         {(props.chartType === "radiologist_tat_trend") &&
          <div style={{
              display: "flex",
              flexDirection:"row-reverse",
              justifyContent: "left",
              paddingBottom: "5px",
            }}>

              {!props.isPortraitMode && (
              <TooltipHost
                content={selectedCount > 0 ? selectedFilters.join(' | ') : t('No filters selected')}
                calloutProps={{ gapSpace: 0 }}
                styles={{ root: { marginLeft: 0, cursor: 'pointer', display: 'inline-block' } }}
              >
                <PrimaryButton
                  className="filter-button-section-analytics"
                  iconProps={{
                    iconName: 'AddTo',
                    cursor: 'pointer',
                     styles: { root: { fontSize: 18 } },
                  }}
                  onClick={() => {
                    setShowFilters((prev) => !prev);
                  }}
                  text={
                    selectedCount > 0
                      ? `${t('productivity-gain.more-filters')} (${selectedCount})`
                      : t('productivity-gain.more-filters')
                  }
                  styles={{
                    root: selectedCount > 0
                      ? { borderColor: "#0078d4", fontWeight: 600 }
                      : {}
                  }}
                />
              </TooltipHost>
              )}
              {/* Show filter summary icon if any filter is selected */}
              {(showFilters || props.showMoreFilters) && (
                <ProductivityGainFilters
                  role={props.role}
                  modalityList={props.modalityList}
                  modalityIds={props.modalityIds}
                  providerList={props.providerList}
                  chartType={props.chartType}
                  setModalityIds={props.setModalityIds}
                  bodyParts={props.bodyParts}
                  setClientIds={props.setClientIds}
                  clientIds={props.clientIds}
                  setPathologyIds={props.setPathologyIds}
                  pathologyIds={props.pathologyIds}
                  setUserIds={props.setUserIds}
                  userIds={props.userIds}
                  setProviderIds={props.setProviderIds}
                  providerIds={props.providerIds}
                  setBodyParts={props.setBodyParts}
                  aiModel={props.aiModel}
                  setAiModel={props.setAiModel}
                  setAlertSuccessModal={props.setAlertSuccessModal}
                  alertSuccessModal={props.alertSuccessModal}
                  handleClearButtonForModality={handleClearButtonForModality}
                  onClickOutside={() => {
                    setShowFilters(false);
                    if (props.setShowMoreFilters) props.setShowMoreFilters(false);
                  }}
                  clientList={props.clientList}
                  xrayBodyParts={props.xrayBodyParts}
                  filterObjInChartComponent={props.filterObjInChartComponent}
                  setFilterObjInChartComponent={props.setFilterObjInChartComponent}
                  normality={props.normality}
                  setNormality={props.setNormality}
                />
              )}
              {/* <div style={{ display: "flex", flexDirection: "column", width: "280px", marginTop: "0px", marginBottom: "5px", padding: "0px 4px" }}>
              <label style={{ fontSize: "12px", fontWeight: 500, marginBottom: "-12px", marginLeft: "5px" }}>
                TAT Mode
              </label> */}
              {/* <div style={{ width: "120px",  marginTop: "22px", marginBottom: "5px", padding:"0px 4px" }}> */}
              {/* <div className="client-filter-section-analytics align-filter-section" style={{width:"200px"}}> */}
              {/* <ComboBox
                // label="TAT Type"
                selectedKey={props.selectedTATType}
                options={[
                  { key: "radiologist_tat_trend", text: "Radiologist" },
                  { key: "study_tat_trend", text: "Study" },
                  { key: "assignment_tat_trend", text: "Assignment"}
                ]}
                onChange={(e, option) => {
                  if (option) props.setSelectedTATType(option.key);
                }}
                comboBoxOptionStyles={customStyles} 
                calloutProps={{ doNotLayer: true }}

              /> */}
              {/* <ChoiceGroup
                //label="TAT Mode" // optional label
                selectedKey={props.selectedTATType}
                options={[
                  { key: "radiologist_tat_trend", text: "Radiologist" },
                  { key: "study_tat_trend", text: "Study" },
                  { key: "assignment_tat_trend", text: "Assignment" }
                ]}
                onChange={(e, option) => {
                  if (option){
                    props.setSelectedTATType(option.key);
                    props.onTATTypeChange(option.key); 
                  }
                }}
                styles={{
                  root: { marginTop: 8 },
                  flexContainer: { display: 'flex', gap: '5px' }, // horizontal layout
                }}
              />
            </div> */}

              {/* <div style={{flexDirection: "row",marginTop: "23px" ,width:"103px"}}> */}
              <div style={{ display: "flex", flexDirection: "column", marginTop: "1px", width: "103px" }}>
                <label style={{ fontSize: "12px", fontWeight: 500, fontFamily: "sans-serif", marginBottom: "-1px",marginLeft:"2px" }}>
                  AI Result
                </label>
              <ComboBox
                selectedKey={props.normality}
                placeholder="Select AI Result"
                options={NORMALITY_OPTIONS}
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  if (option) {
                    props.setNormality(option.key);
                  }
                }}
              />
              </div>
                <div style={{ display: "flex", flexDirection: "column"}}>
                  <label style={{ marginBottom: "-5px", fontSize: "12px", fontWeight: 500 ,marginLeft: "5px", fontFamily: "sans-serif" }}>
                    {/* Reported Date Range */}
                    {props.filterObjInChartComponent.fullDay ? "Reported Date" : "Reported Date Range"}
                    </label>
                  <div style={{ display: "flex", gap: "1px" }}>               
                  <DatePicker
                    className="dform-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    name="dob"
                    style={{ width: "120px", marginTop: "5px", marginBottom: "5px", padding:"0px 4px" }}
                    value={
                      props.filterObjInChartComponent.dateFrom ||
                      new Date(new Date().setMonth(new Date().getMonth() - 1))
                    }
                    onSelectDate={selectDateFrom}
                    strings={defaultDatePickerStrings}
                    placeholder={t("analytics.from")}
                    maxDate={today}
                    formatDate={getConsistentDateFormat}
                  />
                {!props.filterObjInChartComponent.fullDay && (
                  <DatePicker
                    className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    // style={{ width: "180px", margin:"5px",marginBottom:"0px",padding:"0px" }}
                    name="dob"
                    style={{ width: "115px",  marginTop: "5px", marginBottom: "5px", padding:"0px 4px" }}
                    value={props.filterObjInChartComponent.dateTo}
                    onSelectDate={selectDateTo}
                    strings={defaultDatePickerStrings}
                    placeholder={t("analytics.to")}
                    maxDate={today}
                    formatDate={getConsistentDateFormat}
                    // disabled={props.selectedDate == 6 ? false : true}
                    disabled={props.filterObjInChartComponent.fullDay}
                />  
                )}
                  
                </div>
          </div>
          </div>
          
        }
        {(props.chartType === "ai_result") &&
          <div style={{
              display: "flex",
              flexDirection:"row-reverse",
              justifyContent: "left",
              paddingBottom: "5px",
            }}>
              
              <TooltipHost
                content={selectedCount > 0 ? selectedFilters.join(' | ') : t('No filters selected')}
                calloutProps={{ gapSpace: 0 }}
                styles={{ root: { marginLeft: 0, cursor: 'pointer', display: 'inline-block' } }}
              >
              {!(props.filterObjInChartComponent.fullDay) && !props.isPortraitMode && (
                <PrimaryButton
                  className="filter-button-section-analytics"
                  iconProps={{
                    iconName: 'AddTo',
                    cursor: 'pointer',
                    styles: { root: { fontSize: 18 } },
                  }}
                  onClick={() => {
                    setShowFilters((prev) => !prev);
                  }}
                  text={
                    selectedCount > 0
                      ? `${t('productivity-gain.more-filters')} (${selectedCount})`
                      : t('productivity-gain.more-filters')
                  }
                  styles={{
                    root: selectedCount > 0
                      ? { borderColor: "#0078d4", fontWeight: 600 }
                      : {}
                  }}
                />
              )}
              </TooltipHost>
              {props.filterObjInChartComponent.fullDay && (
                <div style={{ display: "flex", gap: "1px", flexDirection:"row" , marginTop: "23px" }}>
                  {props.clientList != undefined && (
                    <ComboBox
                      placeholder={props.role === USERTYPES.ADMIN ? "Select Firm" : "Select Client"}
                      options={props.clientList}
                      selectedKey={props.clientIds}
                      multiSelect
                      calloutProps={{ doNotLayer: true }}
                      allowFreeInput
                      onChange={(e, option) => {
                        let selected = option?.selected;
                        if (option) {
                          props.setClientIds((prev) =>
                            selected ? [...prev, option.key] : prev.filter((k) => k !== option.key)
                          );
                        }
                      }}
                      style={{ minWidth: 140 }}
                    />
                  )}
                  
                  {props.modalityList != undefined && (
                    <ComboBox
                      placeholder="Select Modality"
                      options={props.modalityList}
                      selectedKey={props.modalityIds}
                      multiSelect
                      calloutProps={{ doNotLayer: true }}
                      allowFreeInput
                      onChange={(e, option) => {
                        let selected = option?.selected;
                        if (option) {
                          props.setModalityIds((prev) =>
                            selected ? [...prev, option.key] : prev.filter((k) => k !== option.key)
                          );
                        }
                      }}
                      style={{ minWidth: 136 }}
                    />
                  )}

                  {props.role !== USERTYPES.RADIOLOGIST && props.providerList && (
                    <ComboBox
                      placeholder="Select Provider"
                      options={props.providerList}
                      selectedKey={props.providerIds}
                      multiSelect
                      calloutProps={{ doNotLayer: true }}
                      allowFreeInput
                      onChange={(e, option) => {
                        let selected = option?.selected;
                        if (option) {
                          props.setProviderIds((prev) =>
                            selected ? [...prev, option.key] : prev.filter((k) => k !== option.key)
                          );
                        }
                      }}
                      style={{ minWidth: 141 }}
                    />
                  )}

                  {props.xrayBodyParts != undefined && (
                    <ComboBox
                      placeholder="Select Body Part"
                      options={props.xrayBodyParts}
                      selectedKey={props.bodyParts}
                      multiSelect
                      calloutProps={{ doNotLayer: true }}
                      allowFreeInput
                      onChange={(e, option) => {
                        let selected = option?.selected;
                        if (option) {
                          props.setBodyParts((prev) =>
                            selected ? [...prev, option.key] : prev.filter((k) => k !== option.key)
                          );
                        }
                      }}
                      style={{ minWidth: 141 }}
                    />
                  )}

                  <ComboBox
                    placeholder="Select AI Model"
                    options={MODEL_OPTIONS}
                    selectedKey={props.aiModel}
                    multiSelect
                    calloutProps={{ doNotLayer: true }}
                    allowFreeInput
                    onChange={(e, option) => {
                      let selected = option?.selected;
                      if (option) {
                        props.setAiModel((prev) =>
                          selected ? [...prev, option.key] : prev.filter((k) => k !== option.key)
                        );
                      }
                    }}
                    style={{ minWidth: 139 }}
                  />

                  

                  
                </div>
              )}

              {/* Show filter summary icon if any filter is selected */}
              {(showFilters || props.showMoreFilters) && (
                <ProductivityGainFilters
                  role={props.role}
                  modalityList={props.modalityList}
                  modalityIds={props.modalityIds}
                  chartType={props.chartType}
                  setModalityIds={props.setModalityIds}
                  bodyParts={props.bodyParts}
                  setClientIds={props.setClientIds}
                  clientIds={props.clientIds}
                  setPathologyIds={props.setPathologyIds}
                  pathologyIds={props.pathologyIds}
                  setUserIds={props.setUserIds}
                  userIds={props.userIds}
                  setProviderIds={props.setProviderIds}
                  providerIds={props.providerIds}
                  setBodyParts={props.setBodyParts}
                  aiModel={props.aiModel}
                  setAiModel={props.setAiModel}
                  setAlertSuccessModal={props.setAlertSuccessModal}
                  alertSuccessModal={props.alertSuccessModal}
                  handleClearButtonForModality={handleClearButtonForModality}
                  onClickOutside={() => {
                    setShowFilters(false);
                    if (props.setShowMoreFilters) props.setShowMoreFilters(false);
                  }}
                  clientList={props.clientList}
                  xrayBodyParts={props.xrayBodyParts}
                  filterObjInChartComponent={props.filterObjInChartComponent}
                  setFilterObjInChartComponent={props.setFilterObjInChartComponent}
                />
              )}
            {!props.filterObjInChartComponent.fullDay && (
              <div style={{ display: "flex", flexDirection: "column", marginTop: "0px" }}>
                <label style={{ fontSize: "12px", fontWeight: 500, marginBottom: "-5px", marginLeft: "5px", fontFamily:"sans-serif" }}>
                  Time Range 
                </label>
                <div style={{ display: "flex", gap: "1px" }}>
                
              
              <div className="timepicker-filter-section-analytics align-filter-section" style={{flexDirection:"row", marginTop: "5px",width: "80px"}}>
                <ComboBox
                  placeholder="-- : --"
                  selectedKey={props.filterObjInChartComponent.timeFrom}
                  options={oneHourIntervalTimes}
                  onChange={(e, option) => {
                    if (option) {
                      props.setFilterObjInChartComponent((prev) => ({
                        ...prev,
                        timeFrom: option.key
                      }));
                    }
                  }}
                  allowFreeInput={false}
                  // multiSelect
                  calloutProps={{ doNotLayer: true }}
                  disabled={props.filterObjInChartComponent.fullDay}
                />
              </div>
              <div className="timepicker-filter-section-analytics align-filter-section" style={{flexDirection:"row", marginTop: "5px",width: "80px"}}>
                <ComboBox
                  placeholder="-- : --"
                  selectedKey={props.filterObjInChartComponent.timeTo}
                  options={oneHourIntervalTimes}
                  onChange={(e, option) => {
                    if (option) {
                      props.setFilterObjInChartComponent((prev) => ({
                        ...prev,
                        timeTo: option.key
                      }));
                    }
                  }}
                  allowFreeInput={false}
                  calloutProps={{ doNotLayer: true }}
                  disabled={props.filterObjInChartComponent.fullDay}
                />
              </div>
              </div>
              </div>
              )}
              <div style={{ display: "flex", flexDirection: "column"}}>
              <label style={{ marginBottom: "-5px", fontSize: "12px", fontWeight: 500 ,marginLeft: "5px", fontFamily:"sans-serif" }}>
                  {props.filterObjInChartComponent.fullDay ? "AI Inference Date" : "AI Inference Date Range"}
                </label>
              <div style={{ display: "flex", gap: "1px" }}>
              <DatePicker
                className="dform-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                name="dob"
                style={{ width: "120px", marginTop: "5px", marginBottom: "5px", padding:"0px 4px" }}
                value={
                  props.filterObjInChartComponent.dateFrom ||
                  new Date(new Date().setMonth(new Date().getMonth() - 1))
                }
                onSelectDate={selectDateFrom}
                strings={defaultDatePickerStrings}
                placeholder={t("analytics.from")}
                maxDate={today}
                formatDate={getConsistentDateFormat}
              />
              {/* </div> */}
              {/* <div style={{ display: "flex", flexDirection: "column"}}> */}
              {/* <label style={{ marginBottom: "-5px", fontSize: "12px", fontWeight: 500,    marginLeft: "5px" }}>AI Inference Date From</label> */}
              {!props.filterObjInChartComponent.fullDay && (
              <DatePicker
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                // style={{ width: "180px", margin:"5px",marginBottom:"0px",padding:"0px" }}
                name="dob"
                style={{ width: "115px",  marginTop: "5px", marginBottom: "5px", padding:"0px 4px" }}
                value={props.filterObjInChartComponent.dateTo}
                onSelectDate={selectDateTo}
                strings={defaultDatePickerStrings}
                placeholder={t("analytics.to")}
                maxDate={today}
                formatDate={getConsistentDateFormat}
                // disabled={props.selectedDate == 6 ? false : true}
                disabled={props.filterObjInChartComponent.fullDay}
              />
              )}
          </div>
          </div>
          
          </div>

        }        
        <div style={{
            // width: "40%",
            display: "flex",
            // flexDirection:"row"
            flexDirection:"row-reverse",
             paddingBottom: showFilterButton ? "0px" : "10px"
          }}>
      {/* 3 */}
        {/* <div className="filter-popup-analytics" ref={ref}> */}

        {props.modalityList != undefined && !showFilterButton &&(
          <>
            <div className="modality-filter-section-analytics align-filter-section" style={{flexDirection:"row"}}>
              <ComboBox
                selectedKey={props.modalityIds}
                placeholder="Select Modality"
                options={[...props.modalityList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                label= {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count")? "Select Modality" : "" }
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if((props.chartType != "edit_reports_count" && props.chartType != "returned_studies_count" && props.chartType != "raised_alert_count") && selected && props.modalityIds.length >= 3) {
                    props.setAlertSuccessModal(() => {
                      const newItem = { ...props.alertSuccessModal };
                      newItem.show = true;
                      newItem.heading = "Error";
                      newItem.description = t(
                        "analytics.max-modalities-selected"
                      );
                      return newItem;
                    });
                    return;
                  }

                  if (option) {
                    props.setModalityIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
              {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") && <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => handleClearButtonForModality()} style={{ alignItems:"flex-end",justifyContent:"center",display:"flex"}}>
              <TooltipHost content="Clear">
                <ClearIcon></ClearIcon>
              </TooltipHost>
              </div>}
            </div>
          </>
        )}
        {/* 4 */}
        {props.clientList != undefined && !showFilterButton && (
          <>
            <div className="client-filter-section-analytics align-filter-section">
              <ComboBox
                selectedKey={props.clientIds}
                placeholder={`${
                  props.role === USERTYPES.ADMIN
                    ? "Select Firm"
                    : "Select Client"
                }`}
                options={[...props.clientList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (selected && props.clientIds.length >= 4) {
                    props.setAlertSuccessModal(() => {
                      const newItem = { ...props.alertSuccessModal };
                      newItem.show = true;
                      newItem.heading = "Error";
                      newItem.description = t("analytics.max-clients-selected");
                      return newItem;
                    });
                    return;
                  }
                  if (option) {
                    props.setClientIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
            </div>
          </>
        )}

        {/* 6 */}
        {props.annotationList != undefined  && !showFilterButton && (
          <>
            <div className="pathology-filter-section-analytics align-filter-section">
              <ComboBox
                selectedKey={props.pathologyIds}
                placeholder="Select Findings"
                options={[...props.annotationList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (selected && props.pathologyIds.length >= 6) {
                    props.setAlertSuccessModal(() => {
                      const newItem = { ...props.alertSuccessModal };
                      newItem.show = true;
                      newItem.heading = "Error";
                      newItem.description = t(
                        "analytics.max-pathologies-selected"
                      );
                      return newItem;
                    });
                    return;
                  }
                  if (option) {
                    props.setPathologyIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
            </div>
          </>
        )}
        { props.role == USERTYPES.FIRMADMIN && props.chartType == "returned_studies_count" && props.returnedReasonList != undefined && (
          <>
            <div className="client-filter-section-analytics align-filter-section" style={{flexDirection:"row"}}>
              <ComboBox
                selectedKey={props.returnedReasonIds}
                // selectedKey={selectedUserIds}
                placeholder="Select Return Reason"
                options={[...props.returnedReasonList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                label="Select Return Reason"
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    props.setReturnedReasonIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
              {props.chartType == "returned_studies_count" && <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => handleClearButtonForReturnedReasons()} style={{ alignItems:"flex-end",justifyContent:"center",display:"flex"}}>
              <TooltipHost content="Clear">
                <ClearIcon></ClearIcon>
              </TooltipHost>
              </div>}
            </div>
          </>
        )}

        { props.role == USERTYPES.FIRMADMIN && props.chartType == "raised_alert_count" && props.raiseAlertReasonList != undefined && (
          <>
            <div className="client-filter-section-analytics align-filter-section" style={{flexDirection:"row"}}>
              <ComboBox
                selectedKey={props.raiseAlertReasonIds}
                // selectedKey={selectedUserIds}
                placeholder="Select Raise Alert Reason"
                options={[...props.raiseAlertReasonList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                label="Select Raise Alert Reason"
                comboBoxOptionStyles={customStyles}
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    props.setRaiseAlertReasonIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
              {props.chartType == "raised_alert_count" && <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => handleClearButtonForRaiseAlertReasons()} style={{ alignItems:"flex-end",justifyContent:"center",display:"flex"}}>
              <TooltipHost content="Clear">
                <ClearIcon></ClearIcon>
              </TooltipHost>
              </div>}
            </div>
          </>
        )}
        { props.role == USERTYPES.FIRMADMIN && (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") && props.userList != undefined && (
          <>
            <div className="client-filter-section-analytics align-filter-section" style={{flexDirection:"row"}}>
              <ComboBox
                selectedKey={props.userIds}
                // selectedKey={selectedUserIds}
                placeholder="Select Radiologist"
                options={[...props.userList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                comboBoxOptionStyles={customStyles}
                label= {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count")? "Select Radiologist" : "" }
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    props.setUserIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
              {(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") && <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => handleClearButtonForUser()} style={{ alignItems:"flex-end",justifyContent:"center",display:"flex"}}>
              <TooltipHost content="Clear">
                <ClearIcon></ClearIcon>
              </TooltipHost>
              </div>}
            </div>
          </>
        )}

        {/* 6 */}
        {props.role != USERTYPES.RADIOLOGIST &&
          (props.providerList != undefined) &&
           !showFilterButton && (
            <>
              <div className="client-filter-section-analytics align-filter-section">
                <ComboBox
                  selectedKey={props.providerIds}
                  placeholder="Select Provider"
                  options={[...props.providerList]}
                  multiSelect
                  calloutProps={{ doNotLayer: true }}
                  allowFreeInput
                  autoComplete="on"
                  onChange={(e, option) => {
                    let selected = option?.selected;

                    if (selected && props.providerIds.length >= 6) {
                      props.setAlertSuccessModal(() => {
                        const newItem = { ...props.alertSuccessModal };
                        newItem.show = true;
                        newItem.heading = "Error";
                        newItem.description = t(
                          "analytics.max-providers-selected"
                        );
                        return newItem;
                      });
                      return;
                    }
                    if (option) {
                      props.setProviderIds((prevSelectedKeys) =>
                        selected
                          ? [...prevSelectedKeys, option.key]
                          : prevSelectedKeys.filter((k) => k !== option.key)
                      );
                    }
                  }}
                />
              </div>
            </>
          )}
          </div>
      </div>
    </>
  );
};

export default AnalyticsFilter;
